import React, { Fragment } from 'react';
import { Table, Button, Popup, Icon, Grid } from 'semantic-ui-react';
import SearchTableData from '../../util/SearchTableData';
import ReactExport from 'react-data-export';
import { checkOrganizationalUnitsPrivilege } from '../util/util';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

const LegalEntityTable = ({
    allLegalLeaseholders,
    filteredLegalLeaseholders,
    writePrivilege,
    disabled,
    deletingRowId,
    deletingSaving,
    onDelete,
    onDeleteConfirm,
    onDeleteCancel,
    onAddress,
    onContact,
    onEdit,
    onDetails,
    legalExcelData,
    getLegalResults,
    handleLegalSearchTextChange,
    legalSearchFields,
    selectedOrganizationalUnit,
    activeRole
}) => {
    return allLegalLeaseholders.length ? (
        <Table celled selectable>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan={writePrivilege ? 5 : 4}>
                        <Grid stackable verticalAlign="middle">
                            <Grid.Column width={14}>
                                <SearchTableData
                                    profMozilla
                                    data={allLegalLeaseholders}
                                    getResults={getLegalResults}
                                    filterItem={legalSearchFields}
                                    onSearchTextChange={handleLegalSearchTextChange}
                                />
                            </Grid.Column>
                            <Grid.Column width={2} textAlign="right">
                                <ExcelFile filename="Pravna lica" element={<Popup
                                    trigger={<Button animated="vertical" color="green" basic
                                                     floated="right" fluid
                                                     style={{ textAlign: 'center' }}>
                                        <Button.Content hidden><Icon name="download"/></Button.Content>
                                        <Button.Content visible>
                                            Excel
                                        </Button.Content>
                                    </Button>}
                                    content="Preuzmi Excel"
                                    hideOnScroll
                                    position="top center"
                                />}>
                                    <ExcelSheet dataSet={sanitizeExcelDataSet(legalExcelData)} name="Pravna lica"/>
                                </ExcelFile>
                            </Grid.Column>
                        </Grid>
                    </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                    <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                    <Table.HeaderCell>Naziv</Table.HeaderCell>
                    <Table.HeaderCell>ID broj</Table.HeaderCell>
                    <Table.HeaderCell>Napomena</Table.HeaderCell>
                    {writePrivilege && <Table.HeaderCell></Table.HeaderCell>}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {filteredLegalLeaseholders.map((el, index) => (
                    <Table.Row key={el.id}>
                        <Table.Cell width={1}>{index + 1}.</Table.Cell>
                        <Table.Cell onClick={() => onDetails(el)}>{el.legalEntity.name}</Table.Cell>
                        <Table.Cell onClick={() => onDetails(el)}>{el.legalEntity.idNumber}</Table.Cell>
                        <Table.Cell onClick={() => onDetails(el)}>{el.comment}</Table.Cell>
                        {writePrivilege && (
                            <Table.Cell verticalAlign="middle" className="text-center">
                                {deletingRowId === el.id ? (
                                    <Fragment>
                                        <Popup content="Potvrdi" position="top center" trigger={
                                            <Button circular icon size="tiny" color="blue"
                                                    disabled={deletingSaving} loading={deletingSaving}
                                                    onClick={onDeleteConfirm}>
                                                <Icon name="check"/>
                                            </Button>
                                        }/>
                                        <Popup content="Otkaži" position="top center" trigger={
                                            <Button basic circular icon size="tiny" color="blue"
                                                    disabled={deletingSaving}
                                                    onClick={onDeleteCancel}>
                                                <Icon name="close"/>
                                            </Button>
                                        }/>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <Popup content="Adresa" position="top center" trigger={
                                            <Button basic="true" circular icon="marker" size="tiny" color="orange"
                                                    disabled={disabled || !!deletingRowId}
                                                    onClick={() => onAddress(el)}/>
                                        }/>
                                        <Popup content="Kontakt" position="top center" trigger={
                                            <Button basic="true" circular icon="phone" size="tiny" color="blue"
                                                    disabled={disabled || !!deletingRowId}
                                                    onClick={() => onContact(el)}/>
                                        }/>
                                        <Popup content="Izmjena" position="top center" trigger={
                                            <Button basic="true" circular icon="pencil" size="tiny" color="green"
                                                    disabled={disabled || !!deletingRowId} onClick={() => onEdit(el)}/>
                                        }/>
                                        <Popup content="Brisanje" position="top center" trigger={
                                            <Button basic="true" circular icon="trash alternate" size="tiny" color="red"
                                                    disabled={disabled || !!deletingRowId}
                                                    onClick={() => onDelete(el.id)}/>
                                        }/>
                                    </Fragment>
                                )}
                            </Table.Cell>
                        )}
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    ) : <p>{selectedOrganizationalUnit || !checkOrganizationalUnitsPrivilege(activeRole)
        ? 'Nema podataka za prikaz.'
        : 'Nema podataka za prikaz, potrebno je odabrati članicu.'}</p>;
};

export default LegalEntityTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LegalEntityTable.js